import { getChats } from './getChats';
import { getLastTimeStamp } from '../../reducers/chatList/helpers';
import { TThunkAction } from '../../types/redux/thunk';

export const getChatListNextPage = (): TThunkAction<void> => (dispatch, getState) => {
  const state = getState();
  const { chatList } = state;

  const timestamp = chatList.chats.length ? getLastTimeStamp(chatList.chats) : state.chatList.timestamp;

  dispatch(getChats({ timestamp }));
};
